import { render } from "./Quotations3.vue?vue&type=template&id=36db6df9"
import script from "./Quotations3.vue?vue&type=script&lang=js"
export * from "./Quotations3.vue?vue&type=script&lang=js"
script.render = render

export default script